import { gsap, ScrollTrigger } from "@/composeables/gsap"

function zip(...arrays) {
  const shortestLength = Math.min(...arrays.map(arr => arr.length))

  return Array.from({ length: shortestLength }, (_, i) => arrays.map(arr => arr[i]))
}

function createSectionAnimation(section) {
    const qs = gsap.utils.selector(section);
    const wrapper = qs('.section-pinned-media__slides')
    const slides = qs('.section-pinned-media__slide')
    const mediaAreas = qs('.section-pinned-media__media-area')
    const contentAreas = qs('.section-pinned-media__content-area')

    const items = zip(slides, mediaAreas, contentAreas)

    if (items.length === 0) {
        return
    }

    const mm = gsap.matchMedia()
    mm.add({
        isMobile: `(max-width: 1023px)`,
        isLg: "(min-width: 1024px)"
    }, (context) => {
        let { isLg } = context.conditions;

        const timeline = gsap.timeline()

        gsap.set([mediaAreas, contentAreas], {
            willChange: 'transform, opacity'
        })

        timeline
            .set(mediaAreas.slice(1), isLg ? { xPercent: 100 } : { yPercent: 100 })
            .set(contentAreas.slice(1), isLg ? { xPercent: -100, autoAlpha: 0 } : { yPercent: -100, autoAlpha: 0 })

        // first slide
        items.slice(0, 1).forEach(([slide, media, content], index, items) => {
            timeline
                .to(content, { autoAlpha: 0 }, "+=0.5")
        })

        // in between slides
        items.slice(1, -1).forEach(([slide, media, content], index, items) => {
            timeline
                .to(media, isLg ? { xPercent: 0 } : { yPercent: 0 })
                .to(content, isLg ? { xPercent: 0, autoAlpha: 1 } : { yPercent: 0, autoAlpha: 1 }, "<")
                .to(content, { autoAlpha: 0 }, "+=0.5")
        })

        // last slide
        items.slice(-1).forEach(([slide, media, content], index, items) => {
            timeline
                .to(media, isLg ? { xPercent: 0 } : { yPercent: 0 })
                .to(content, isLg ? { xPercent: 0, autoAlpha: 1 } : { yPercent: 0, autoAlpha: 1 }, "<")
        })


        ScrollTrigger.create({
            trigger: wrapper,
            start: "top top",
            end: `bottom+=${Math.min(100, items.length + 1 * (isLg ? 100 : 100))}% bottom`,
            scrub: true,
            pin: true,
            markers: false,
            animation: timeline,
            invalidateOnRefresh: true,
            onLeave() {
                ScrollTrigger.refresh()
            }
        })

    })

}

export const init = () => {
    const sections = gsap.utils.toArray(".section-pinned-media");

    sections
        .forEach(createSectionAnimation)
};

export default init;
